export const APP_BUILD_ID = typeof __APP_BUILD_ID__ === 'string'
  ? __APP_BUILD_ID__
  : 'v1.0.1+test'
